import { PcApiResponse } from '@/api/pc-api/types';
import { StatType } from '@/api/pc-api/v1/{authInfoId}/service-stat/type';
import { PREFIX_PATH } from '@/lib/axios/axiosInterceptor';
import { api } from '@/utils/api';

type Args = {
  statType: StatType;
  statDate: string;
  svcId?: string;
};

export type RequestRangeStatics = {
  category: string;
  requestCount: number;
  completeCount: number;
  completeRatio: number;
};

export const getRequestRangeStatics = (args: Args) => {
  return api<PcApiResponse<RequestRangeStatics[]>>(
    'get',
    `/pc-api/v1/${PREFIX_PATH}/service-stat/request-range-statics`,
    args
  );
};
